import styled from 'styled-components';

export const StyledSlideshow = styled.div`
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
`;

export const StyledSlideshowSlider = styled.div`
    width: ${( { useParentWidth, numberOfChildren } ) => {
    if( useParentWidth ) {
        return `100%`
    } else {
        return `calc(((100vw - 100px) / 8 * 6) * ${numberOfChildren})`
    }
}};
    left: ${( { useParentWidth, parentWidth, index } ) => {
    if( useParentWidth ) {
        return `calc(${parentWidth} * ${-index})`
    } else {
        return `calc(((100vw - 100px) / 8 * 6) * ${-index})`
    }
}};
    white-space: nowrap;
    transition: ease 1000ms;
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    @media only screen and (max-width: 885px) {
        width: ${( { useParentWidth, parentWidth, numberOfChildren } ) => {
    if( useParentWidth ) {
        return `calc((${parentWidth} - 60px))`
    } else {
        return `calc((100vw - 60px) * ${numberOfChildren})`
    }
}};
        left: ${( { useParentWidth, parentWidth, index } ) => {
    if( useParentWidth ) {
        return `calc((${parentWidth} - 60px) * ${-index})`
    } else {
        return `calc((100vw - 60px) * ${-index})`
    }
}};
    }
`;

export const StyledSlide = styled.div`
    display: inline-block;
    height: 100%;
    min-width: ${( { useParentWidth } ) => {
    if( useParentWidth ) {
        return `100%`
    } else {
        return `calc((100vw - 100px) / 8 * 6)`
    }
}};
    margin: 0px;
    padding: 0px 50px;
    @media only screen and (max-width: 885px) {
        width: ${( { useParentWidth, parentWidth, numberOfChildren } ) => {
    if( useParentWidth ) {
        return `calc((${parentWidth}))`
    } else {
        return `calc(100vw - 60px)`
    }
}};
        padding: 0px;
        padding-left: 30px;
        padding-right: 30px;
        &:first-child{
            margin-left: 30px;
        }
    }
`;

export const SlideshowDots = styled.div`
    text-align: center;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
`;

export const SlideshowDot = styled.div`
    display: inline-block;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    cursor: pointer;
    margin: 15px 3.5px 0px;
    background-color: ${({ active }) => active ?"var(--color-primary)":"#c4c4c4"};
`;

export const OverlayContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
`;

export const OverlayButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${({position}) =>position==="left"?"flex-start":"flex-end"};
    height: 100%;
    width: 30%;
    z-index: 1;
    
    svg{
        line{
            stroke: #CACACA;
            transition: all .24s;
        }
    }
    
    &:hover svg{
        line{
            stroke: var(--color-primary);
        }
    }
`;

export const OverlayButton = styled.div`
    height: 30px;
    width: 30px;
    border-radius: 30px;
    background-color: #c4c4c4;
    z-index: 2;
    :hover {
        background-color: var(--color-primary);
    }
    margin: 10px;
    @media only screen and (max-width: 885px) {
        margin: 0px;
        height: 20px;
        width: 20px;
    }
`;
